import { render, staticRenderFns } from "./computer.vue?vue&type=template&id=3e9e1660&scoped=true"
import script from "./computer.vue?vue&type=script&lang=js"
export * from "./computer.vue?vue&type=script&lang=js"
import style0 from "./computer.vue?vue&type=style&index=0&id=3e9e1660&prod&lang=scss&scoped=true"
import style1 from "./computer.vue?vue&type=style&index=1&id=3e9e1660&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9e1660",
  null
  
)

export default component.exports